import { GoogleGenerativeAI } from "@google/generative-ai";

const REACT_APP_GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;
console.log(REACT_APP_GEMINI_API_KEY)
const genAI = new GoogleGenerativeAI(REACT_APP_GEMINI_API_KEY);

export async function sendToGemini(promptText) {
  const defaultPrompt = `This is my course outline, can you create an efficient study schedule 2 weeks prior to each assignment and exam. Each study session should only be 1–2 hours at a good time of the day and should not overlap other events in my calendar. Only 2–3 study sessions per week. Just display the due dates, and each study session. Do not ask any more follow up questions or ask for more detail.`;

  const fullPrompt = `${promptText}\n\n${defaultPrompt}`;

  try {
    const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // or "gemini-pro" or "gemini-1.5-pro"

    const result = await model.generateContent(fullPrompt);
    const response = await result.response;
    const text = await response.text();

    return text || "No response from Gemini.";
  } catch (err) {
    console.error("Gemini API error:", err);
    return "Failed to get response from Gemini.";
  }
}

export async function getJSONschedule(promptText) {
  try {
    const defaultPrompt = `${promptText}\n\n\n
      This is my course outline. Create a study schedule starting two weeks before each assignment or exam.

      Requirements:
      - Only 2–3 study sessions per week
      - Study sessions should be 1–2 hours long
      - Use good times (e.g., 6–9pm)
      - Output ONLY valid JSON — do not include explanations or markdown.

      Format:
      {
        "events": [
          {
            "summary": "Study Session",
            "description": "Review for Assignment 1",
            "start": "2025-05-01T18:00:00-04:00",
            "end": "2025-05-01T19:00:00-04:00"
          },
        ]
      }
      `;
    const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // or "gemini-pro" or "gemini-1.5-pro"

    const result = await model.generateContent(defaultPrompt);
    const response = await result.response;
    const text = await response.text();

    return text || "No response from Gemini.";
  } catch (err) {
    console.error("Gemini API error:", err);
    return "Failed to get response from Gemini.";
  }
}
